var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.51 48.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".rect{fill:inherit;}.cls-2{fill:none;stroke:#b3b3b3;stroke-miterlimit:10;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "rect",
    width: 48.51,
    height: 48.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.63,
    y1: 9.64,
    x2: 38.88,
    y2: 38.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 9.63,
    y1: 38.89,
    x2: 38.88,
    y2: 9.64
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c6c98027.svg";
export { ForwardRef as ReactComponent };